import { Component } from '@angular/core';
import { BaseRow } from '../base-row';

@Component({
    selector: 'app-refund-row',
    templateUrl: './refund-row.component.html',
    styleUrls: ['./../base-row.component.scss'],
    standalone: false
})
export class RefundRowComponent extends BaseRow {
}
